<script>
export default {
    data() {
        return {
            error: '',
            pwd: ''
        }
    },
    methods: {
        async confirm() {
            this.error = ''
            let result = await this.$http.checkAdminPwd(this.pwd)
            if (result == 'success') {
                this.$emit('checked')
            } else {
                this.error = '密码错误'
            }
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>

<template>
    <Dialog btn-text="提交" title="请输入管理员密码" @confirm="confirm" @close="close" class="CheckPwdDialog" >
        <DialogBaseInput v-model="pwd" :error="error" type="password" @keyup.enter.native="confirm" />
    </Dialog>
</template>

<style lang="scss" scoped>
.DialogBaseInput {
       margin: 33px 21px 20px; 
}
</style>





// WEBPACK FOOTER //
// src/components/acount/CheckPwdDialog.vue